<template>
  <DatePicker
    :popover="popover"
    :value="value"
    @input="$emit('input', $event)"
    :timezone="timezone"
    mode="dateTime"
  >
    <template v-slot="{ inputValue, inputEvents }">
      <v-text-field
        :rules="[rules.required]"
        :value="inputValue"
        :label="label"
        prepend-icon="event"
        readonly
        color="primary"
        v-on="inputEvents"
        :prefix="momentTz.tz(timezone).format('z')"
        :hint="hint"
        persistent-hint
      >
        {{ inputValue }}
        <template v-if="is_tooltip && tooltip_content" v-slot:append>
          <v-tooltip top color="white">
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" v-on="on">mdi-information-outline</v-icon>
            </template>
            <div
              class="grey--text text--darken-3 body-1"
              v-html="tooltip_content"
            >
              {{ tooltip_content }}
            </div>
          </v-tooltip>
        </template>
      </v-text-field>
    </template>
  </DatePicker>
</template>
<script>
import Calendar from "v-calendar/lib/components/calendar.umd";
import DatePicker from "v-calendar/lib/components/date-picker.umd";
import rules from "@/validation";
import { mapGetters } from "vuex";
export default {
  props: [
    "value",
    "label",
    "datetime",
    "is_tooltip",
    "tooltip_content",
    "hint",
  ],
  name: "dateTimePicker",
  data() {
    return {
      rules,
      popover: {
        visibility: "focus",
        positionFixed: true,
      },
    };
  },
  computed: {
    ...mapGetters("company", {
      timezone: "getSelectedCompanyTimezone",
    }),
  },
  components: {
    Calendar,
    DatePicker,
  },
};
</script>
